<template>
  <div :class="$route.query.key != 1 ? 'mainDiv' : ''">
    <div class=" worker" @click="dialogTableVisible = true">
      <div v-if="choseStaffId == ''">
        <img src="@public/img/worker.png" alt="" />
        选择员工
      </div>
      <div v-else>员工：{{ showStaff }}</div>
    </div>
    <div v-if="this.$route.query.key != 1">
      <el-checkbox
        v-model="typeMethods"
        label="减积分"
        border
        style="margin-top: 10px"
        @change="changeType"
      ></el-checkbox>
      <el-checkbox
        v-model="typeMethods2"
        label="加积分"
        border
        style="margin-top: 10px"
        @change="changeType2"
      ></el-checkbox>
      <div class="headline">
        {{ tableList.length ? "选择积分商品" : "暂无积分商品" }}
      </div>
    </div>
    <div class="headline" v-else>
      {{ tableList.length > 0 ? "选择商品" : "暂无商品" }}
    </div>
    <el-input
      v-if="$route.query.key == 1"
      v-model="seach_shop"
      clearable
      @clear="clear_shop"
      @blur="guanbi"
      placeholder="请输入商品关键词"
    >
      <el-button slot="append" icon="el-icon-search" @click="onSeach_shop"></el-button>
    </el-input>
    <el-input
      v-if="$route.query.key == 1"
      style="opacity:0;width:10px;height: 2px"
      ref="inputbox"
      @change="keyup_submit"
      size="mini"
      v-model="Inputs_Focus"
      @blur="Blur"
    ></el-input>
    <div class="shell" v-if="$route.query.key == 1">
      <div
        class="oil-item"
        v-for="(item, index) in tableList"
        :key="index"
        :class="nowIdx == index ? 'oil-item_active' : ''"
        @click="keyup_submit(item, 1, index)"
      >
        <img :src="item.url == '' ? item.pic : item.url" alt="" />
        <div class="message">
          <p
            style="width: 70px;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow:ellipsis;"
            :title="item.title"
          >
            {{ item.title }}
          </p>
          <p
            style="width: 70px;color: red;text-align: center;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
            :title="item.money"
          >
            {{ item.money }}
          </p>
        </div>
      </div>
    </div>
    <div class="shell" v-else>
      <div
        class="oil-item"
        v-for="(item, index) in tableList"
        :key="index"
        :class="nowIdx == index ? 'oil-item_active' : ''"
        @click="selectOil(index)"
      >
        <img :src="item.pic" alt="" />
        <div class="message">
          <p>{{ item.title }}</p>
          <p>{{ item.credit }}</p>
        </div>
      </div>
    </div>

    <!-- 員工选择弹窗 -->
    <el-dialog
      title="选择员工"
      :visible.sync="dialogTableVisible"
      @close="guanbi"
    >
      <div class="poPup">
        <div
          v-for="item in staffData"
          :key="item.id"
          :class="choseStaffId == item.id ? 'chose' : ''"
          @click="clickButton(item.id)"
        >
          {{ item.name }}（{{ item.id }}）
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { productList } from "@/api/integralMall";
import { mapActions, mapGetters } from "vuex";
import { get_goods_info_by_barcode } from "@/api/order";
// import { equipmentList } from "@/api/vip";
import { employeeList } from "@/api/employee";

export default {
  computed: {
    ...mapGetters(["token", "app_id", "carList", "get_focus"])
  },
  watch: {
    Inputs_Focus(val) {
      this.$refs.inputbox.focus();
    },
    get_focus(val) {
      console.log(val);
      this.$refs.inputbox.focus();
    }
  },
  data() {
    return {
      seach_shop:'',
      Inputs_Focus: "",
      dialogTableVisible: false,
      activeName: "选择油品",
      moneyTabs: ["选择油品"],
      tableList: [],
      staffData: [],
      choseStaff: "",
      nowIdx: 0,
      choseStaffId: "", //选择员工的id，
      showStaff: "",
      typeMethods: false, //false,兑换积分商品 true， 给客户减积分
      typeMethods2: false //false,兑换积分商品 true， 给客户减积分
    };
  },
  created() {
    this.getipmentList();
    if (this.$route.query.key == 1) {
      this.$nextTick(_ => {
        this.$refs.inputbox.focus();
      });
    }
  },
  mounted() {},
  methods: {
    ...mapActions(["addGoods", "setData", "setFocus"]),
    //失去焦点
    Blur() {
      this.setFocus(false);
    },
    onSeach_shop(){
      this.getipmentList(this.seach_shop)
    },
    clear_shop(){
      this.getipmentList()
      this.guanbi()
    },
    guanbi() {
      this.$refs.inputbox.focus();
    },
    async keyup_submit(item, key, idx) {
      if (key == 1) {
        this.nowIdx = idx;
        this.setData(item);
        this.addGoods(item);
        this.$refs.inputbox.focus();
        return false;
      }
      console.log("2222", this.Inputs_Focus);
      const goods_by_barcode_res = await get_goods_info_by_barcode({
        app_id: this.app_id,
        bar_code: this.Inputs_Focus
      });
      if (goods_by_barcode_res.code == 200) {
        console.log(goods_by_barcode_res.data);
        this.setData(goods_by_barcode_res.data);
        this.addGoods(goods_by_barcode_res.data);
        this.Inputs_Focus = "";
        this.$refs.inputbox.focus();
      } else {
        this.$message.error(goods_by_barcode_res.msg);
        this.Inputs_Focus = "";
        this.$refs.inputbox.focus();
      }
    },
    changeType(val) {
      if (val) {
        this.nowIdx = "a";
        this.typeMethods2 = false;
      }
      console.log("操作方式", val);
      this.$parent.typeMethods = 2;
    },
    changeType2(val) {
      if (val) {
        this.nowIdx = "a";
        this.typeMethods = false;
      }
      console.log("操作方式", val);
      this.$parent.typeMethods = 1;
    },
    // 员工选择弹窗
    clickButton(id) {
      console.log("员工选择弹窗", id);
      this.choseStaffId = id;
      this.showStaff = this.staffTitleTransiform(id);
      localStorage.setItem("choseStaffId", id);
      this.dialogTableVisible = false;
      this.$refs.inputbox.focus();
    },
    staffTitleTransiform(id) {
      let title = "";
      console.log("判断数据", this.staffData, id);
      this.staffData.forEach(item => {
        if (item.id == Number(id)) {
          title = item.name + "(" + item.id + ")";
        }
      });
      return title;
    },
    selectOil(idx, item) {
      this.typeMethods = false;
      this.typeMethods2 = false;
      this.$parent.typeMethods = 0;
      this.nowIdx = idx;
      this.$parent.oil_infor = this.tableList[idx];
      // this.$parent.recount();
    },
    getipmentList(keyword) {
      this.loading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        // page: this.page,
        // limit: 10,
        status: 1,
        buy_method: 1
      };
      if (this.$route.query.key == 1) {
        data.buy_method = 3;
      }
      if(keyword){
        data.keyword = keyword
      }
      this.tableList = [];
      productList(data).then(res => {
        console.log("商品列表", res);
        if (res.code == 200) {
          var result = res.data;
          this.total_num = res.data.total_num;
          if (result.length > 0) {
            this.tableList = result;
            this.$parent.oil_infor = this.tableList[this.nowIdx];
          } else {
            this.$message.error("暂无数据....");
          }
        }
      });
      employeeList({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          this.staffData = res.data;
          if (localStorage.getItem("choseStaffId")) {
            //
            this.choseStaffId = localStorage.getItem("choseStaffId");
            this.showStaff = this.staffTitleTransiform(this.choseStaffId);
          }
        }
        console.log("员工数据", res);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.mainDiv {
  height: 100%;
  overflow-y: auto;
}
.headline {
  height: 50px;
  line-height: 50px;
  padding-left: 14px;
}
.worker {
  height: 50px;
  background: #409eff;
  border-radius: 10px;
  padding-left: 14px;
  display: flex;
  color: #fff;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
  img {
    height: 30px;
    margin-right: 10px;
  }
}
// 员工选择弹窗
.poPup {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  div {
    width: 180px;
    height: 60px;
    border-radius: 5px;
    border: 1px solid #ccc;
    text-align: center;
    line-height: 60px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .chose {
    background: #8cc5ff;
    color: #fff;
  }
}
.el-card {
  font-size: 16px;
  color: #ffffff;
  background: #f56c6c !important;
  .card-body {
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: space-between;
    .order-item-info {
      display: flex;
      font-size: 14px;
      color: #f2f2f2;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}
.shell {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.oil-item {
  width: 45%;
  min-height: 80px;
  // background: #f2f2f2;
  border: 1px solid #f2f2f2;
  color: #22242f;
  cursor: pointer;
  font-size: 14px;
  padding-left: 10px;
  border-radius: 10px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  img {
    width: 50px;
    border-radius: 5px;
  }
  .message {
    padding-left: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
.oil-item_active {
  border: 1px solid #409eff;
  color: #409eff;
}
</style>
